export default __webpack_public_path__ + "static/media/1993.2e59e090.png";